/**
 * Consentimiento de cookies de marketing y medición (Meta Pixel + Google Analytics) — Ley 19.628 / 21.719.
 *
 * Opt-in: sin decisión guardada = sin Pixel ni GA. Vercel Analytics no usa cookies y
 * no depende de esto. La decisión vive en localStorage del navegador; si el
 * storage falla (modo privado, bloqueado) se trata como "sin decidir".
 */

export type MarketingConsent = 'granted' | 'denied';

// Subir la versión obliga a volver a preguntar (p. ej. si se agrega otro proveedor).
// v2: se agregó Google Analytics → el consentimiento v1 (solo Meta) ya no alcanza.
const STORAGE_KEY = 'cc_consent_marketing_v2';
const CHANGE_EVENT = 'cc-consent-change';
const OPEN_EVENT = 'cc-consent-open';

export function getMarketingConsent(): MarketingConsent | null {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return value === 'granted' || value === 'denied' ? value : null;
  } catch {
    return null;
  }
}

export function setMarketingConsent(value: MarketingConsent) {
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // Sin storage la decisión dura solo esta visita.
  }
  window.dispatchEvent(new CustomEvent<MarketingConsent>(CHANGE_EVENT, { detail: value }));
}

export function onMarketingConsentChange(cb: (value: MarketingConsent) => void) {
  const handler = (e: Event) => cb((e as CustomEvent<MarketingConsent>).detail);
  window.addEventListener(CHANGE_EVENT, handler);
  return () => window.removeEventListener(CHANGE_EVENT, handler);
}

/** Reabre el banner (link "Configurar cookies" en /privacidad). */
export function openConsentBanner() {
  window.dispatchEvent(new Event(OPEN_EVENT));
}

export function onConsentBannerOpen(cb: () => void) {
  window.addEventListener(OPEN_EVENT, cb);
  return () => window.removeEventListener(OPEN_EVENT, cb);
}

/** Rutas públicas donde existe medición de marketing (y donde se muestra el banner). */
const MARKETING_PATHS = [/^\/$/, /^\/terapista\/[^/]+\/?$/, /^\/blog\/?$/, /^\/agendar\/?$/, /^\/privacidad\/?$/];

export const isMarketingPath = (pathname: string) => MARKETING_PATHS.some((re) => re.test(pathname));
